import { connectRouter, LocationChangeAction, RouterState } from "connected-react-router";
import { History } from "history";
import { Reducer } from "react";
import { combineReducers } from "redux";

import * as settingsStore from "./Slice/SettingsSlice";
import * as contentTypesStore from "./Slice/ContentTypesSlice";
import * as pageHeaderStore from "./Slice/PageHeaderSlice";
import * as taxonomiesStore from "./Slice/TaxonomiesSlice";
import * as categoriesStore from "./Slice/CategoriesSlice";
import * as contentTypeConfigsStore from "./Slice/ContentTypeConfigsSlice";
import * as macroDataStore from "./Slice/MacroDataSlice";

// Re-exported as namespaces so call sites can write e.g. `categoriesStore.fetchCategories` /
// `categoriesStore.CategoriesState` with autocomplete instead of importing each slice file directly.
export { settingsStore, contentTypesStore, pageHeaderStore, taxonomiesStore, categoriesStore, contentTypeConfigsStore, macroDataStore };

// Must mirror the combineReducers map below key-for-key : this is what typed selectors run against.
export interface IApplicationState {
    router: Reducer<RouterState, LocationChangeAction>;
    settings: settingsStore.ISettingsState;
    contentTypes: contentTypesStore.ContentTypesState;
    pageHeader: pageHeaderStore.PageHeaderState;
    taxonomies: taxonomiesStore.TaxonomiesState;
    categories: categoriesStore.CategoriesState;
    contentTypeConfigs: contentTypeConfigsStore.ContentTypeConfigsState;
    macroData: macroDataStore.MacroDataState;
}

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        settings: settingsStore.reducer,
        contentTypes: contentTypesStore.reducer,
        pageHeader: pageHeaderStore.reducer,
        taxonomies: taxonomiesStore.reducer,
        categories: categoriesStore.reducer,
        contentTypeConfigs: contentTypeConfigsStore.reducer,
        macroData: macroDataStore.reducer,
    });

export default createRootReducer;
